import qs from "qs";
import { put, call, race, delay } from "redux-saga/effects";
import http from "~/utils/config/http";
import axios from "axios";
import oauth from "~/utils/oauth";
import * as actions from "../actions";
import { PORTALRH_MIDDLEWARE } from "~/utils/constants";
import {
  toastActiveError,
  toastActiveWarning,
  toastInfoLogin,
} from "~/components/Toast/actions";
import moment from "moment";
import { SIGN_PDF_LOCAL_APP_URL } from "~/utils/constants";
import { checkToken } from "~/store/ducks/oauth/sagas";

import { setTemporaryUser } from "~/store/ducks/registerOrgAdmin/actionTypes";

import {
  GLOBAL_SOLVER_MIDDLEWARE,
  GRANT_TYPE_PASSWORD,
  IFLOW_APP,
} from "~/utils/constants";
const devLogConsole = require("~/utils/devLog");
/*Uniksystem*/

export function* postToken({ data }) {
  try {
    const resp = yield http.post("/oauth/token", qs.stringify(data));
    const { access_token, refresh_token, expires_in } = resp.data;

    document.cookie = "Bearer=" + access_token + ";path=/";

    oauth.setToken(
      {
        access_token,
        refresh_token,
        expires_in,
      },
      true
    );
    return resp;
  } catch (exception) {
    // yield put(actions.failCredentials());
    yield call(throwsException, exception);
  }
}

//TODO: é preciso meter mensagem a dizer que esta checkedin
export function* requestLogin({ data, checkAdminConfigFile }) {
  // Cleaning localStorage
  oauth.clearAppStorage();

  // Check for missing config file and thus starting the reset password process
  if (checkAdminConfigFile) {
    try {
      yield http.get("api/open/confirm-admin");
    } catch (e) {
      if (e.response && e.response.status === 400) {
        yield put(setTemporaryUser({ email: "admin" }));
        yield put(actions.failCredentials());
        window.location.href = `/#/insert-code`;
        return;
      }
    }
  }

  let status;
  let respCooldown = { data: null };
  try {
    const cooldownResponse = yield http.get(
      `/api/open/loginCooldown?username=${data.username}&isIntegratedLogin=${
        data.isIntegratedLogin ? "true" : "false"
      }`
    );
    respCooldown = cooldownResponse.data;
  } catch (e) {
    if (e.response && e.response.status === 409) {
      respCooldown = e.response.data;
    }
  }

  try {
    const resp = yield call(postToken, { data });
    status = resp.status;
  } catch (exception) {
    const { response } = exception;
    status = response ? response.status : 500;
  }

  const payload = { username: data.username, status };
  try {
    yield http.post("/api/open/validateLogin", payload);
    if (status === 200) {
      yield put(actions.successLogin());
    } else if (status === 203) {
      const { startDate, expectedDuration } = respCooldown;
      const formattedStartDate = moment(startDate).format("HH:mm");
      const cooldownInfo = { startDate: formattedStartDate, expectedDuration };
      yield put(actions.failCredentials());
      yield put(toastInfoLogin(cooldownInfo));
    } else if (status === 400 || status === 428 || status === 417) {
      yield put(actions.failCredentials());
      yield put(toastActiveWarning("login.error.badCredentials"));
    } else {
      yield put(actions.failRemoteServer());
      yield put(toastActiveError("login.error.connectionRemoteServer"));
    }
  } catch (validateException) {
    yield put(actions.failRemoteServer());
    yield put(toastActiveError("login.error.connectionRemoteServer"));
  }
}

export function* requestRegistarPonto({ payload, date }) {
  try {
    const tokenResponse = yield call(postToken, { data: payload });

    const token = tokenResponse.data.access_token;
    const headers = {
      Authorization: `Bearer ${token}`,
      ...PORTALRH_MIDDLEWARE,
    };

    const response = yield call(
      http.post,
      "/api/timesheet/record/checks",
      date,
      { headers }
    );

    if (response.status === 200) {
      const responseData = response.data;
      const time = new Date(responseData).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      yield put(actions.setCheckInOutAuthMessage(time, "success"));
    } else {
      yield put(actions.setCheckInOutAuthMessage("NOOK", "error"));
    }
  } catch (exception) {
    yield put(actions.setCheckInOutAuthMessage("NOOK", "error"));
  }
}

/*Global Solver*/
export function* requestLoginGlobalSolver({ data }) {
  try {
    yield put(actions.setGlobalSolverAuthenticated(false));
    const resp = yield http.post(
      "/api/open/authenticate",
      data,
      GLOBAL_SOLVER_MIDDLEWARE
    );
    const access_token_global_solver = resp.data;
    oauth.setGlobalSolverToken(access_token_global_solver, true);
    yield put(actions.setGlobalSolverAuthenticated(true));
  } catch (exception) {
    const { response } = exception;
    if (!response) {
      yield put(actions.failRemoteServer());
    }
    if (exception.message === "Network Error") {
      yield put(actions.failRemoteServer());
      yield put(toastActiveError("login.error.connectionRemoteServer"));
    } else if (response && response.data.error === "invalid_grant") {
      yield put(actions.failCredentials());
      yield put(toastActiveWarning("login.error.badCredentials"));
    }
  }
}

/*Google*/
export function* requestGoogleSignIn({ response }) {
  oauth.clearAppStorage();
  try {
    const googleResponse = yield http.post(
      "/api/open/auth/google/signin",
      response.tokenId
    );
    googleResponse.data.grant_type = GRANT_TYPE_PASSWORD;
    yield call(doGenericLogin, googleResponse);
  } catch (exception) {
    yield put(actions.failCredentials());
    yield call(throwsException, exception);
  }
}

/*Microsoft*/
export function* requestMicrosoftSignIn({ response }) {
  oauth.clearAppStorage();
  try {
    const microsoftResponse = yield call(
      http.post,
      "/api/open/auth/microsoft/signin",
      response.idToken
    );
    microsoftResponse.data.grant_type = GRANT_TYPE_PASSWORD;
    microsoftResponse.data.isIntegratedLogin = true; // Adiciona o campo extra

    yield call(doGenericLogin, microsoftResponse); // Passa microsoftResponse.data para doGenericLogin
  } catch (exception) {
    yield put(actions.failCredentials());
    yield call(throwsException, exception);
  }
}

/*LDAP*/
export function* requestLDAPSignIn({ authentication }) {
  oauth.clearAppStorage();
  try {
    const adResponse = yield http.post(
      "/api/open/auth/ldap/signin",
      authentication
    );
    devLogConsole("adResponse", adResponse);
    adResponse.data.grant_type = GRANT_TYPE_PASSWORD;
    yield put(actions.setLDAPSignIn(adResponse));
    yield call(doGenericLogin, adResponse);
  } catch (exception) {
    yield put(actions.failCredentialsLDPA());
    yield put(actions.setLDAPSignIn(exception));
    yield call(throwsException, exception, true);
  }
}

/*SAML - BEGIN*/
export function* getSAMLRequestURL() {
  try {
    let response = yield http.get("/api/open/auth/saml/request/0");
    yield put(actions.setSAMLRequestURL(response.data));
  } catch (exception) {
    yield call(throwsException, exception);
  }
}

export function* signInSAML({ payload }) {
  oauth.clearAppStorage();
  try {
    let samlResponse = yield http.post("/api/open/auth/saml/signin", payload);
    samlResponse.data.grant_type = GRANT_TYPE_PASSWORD;
    yield call(doGenericLogin, samlResponse);
    yield put(actions.signedInSAML(true));
  } catch (exception) {
    yield put(actions.signedInSAML(false));
    yield call(throwsException, exception);
  }
}

export function* doGenericLoginFromIntranet({ data }) {
  oauth.clearAppStorage();
  try {
    devLogConsole(data);

    let access_token = data?.access_token;
    let refresh_token = data?.refresh_token;
    let expires_in = data?.expires_in;

    document.cookie = "Bearer=" + access_token + ";path=/";

    oauth.setToken(
      {
        access_token,
        refresh_token,
        expires_in,
      },
      true
    );
    yield put(actions.setIntranetLogin());
  } catch (exception) {}
}

/*SAML - END*/

export function* doGenericLogin({ data }) {
  let status;
  try {
    const loginCooldownUrl = `/api/open/loginCooldown?username=${
      data.username
    }&isIntegratedLogin=${data.isIntegratedLogin ? "true" : "false"}`;

    const respCooldown = yield http.get(loginCooldownUrl);
    if (respCooldown.status === 200) {
      const resp = yield call(postToken, { data });
      status = resp.status;
      yield put(actions.successLogin());
    } else {
      yield put(actions.failCredentials());
      yield put(toastActiveError(respCooldown.body));
    }
  } catch (exception) {
    yield put(actions.failCredentials());
    status = exception.response ? exception.response.status : 500; // Default to 500 if no response
  } finally {
    const payload = {
      username: data.username,
      status: status,
    };
    if (data.isIntegratedLogin) {
      payload.isIntegratedLogin = true;
    }
    yield http.post("/api/open/validateLogin", payload);
  }
}

//KEYCLOAK AUTH
export function* doKeycloakSignIn({ data }) {
  try {
    let response = yield http.get("/api/open/config/keycloak-auth");
    if (response.data.keycloakAuth) {
      yield put(actions.setAuthKeycloakAuthConfig(true));
    } else {
      yield put(actions.setAuthKeycloakAuthConfig(false));
    }
  } catch (exception) {
    yield put(actions.setAuthKeycloakAuthConfig(false));
  }
}

//WINDOWS AUTH
export function* doWindowsSignIn({ data }) {
  oauth.clearAppStorage();
  try {
    let login = data.login;
    let uuid = data.uuid;

    if (login !== undefined && login !== null) {
      let responseAux = "";

      if (data.platform === "windows") {
        let obj = {
          username: login,
        };
        responseAux = yield http.post(
          "/api/open/config/" + data.platform + "-auth/" + uuid,
          obj
        );
      } else {
        responseAux = yield http.get(
          "/api/open/config/" + data.platform + "-auth/" + login + "/" + uuid
        );
      }
      responseAux.data.grant_type = GRANT_TYPE_PASSWORD;
      if (data.platform === "windows") {
        window.history.pushState({}, "Uniksystem", window.location.pathname);
        yield put(actions.setAuthWindowsAuthConfig(false));
      } else if (data.platform === "keycloak") {
        window.history.pushState({}, "Uniksystem", window.location.pathname);
        yield put(actions.setAuthKeycloakAuthConfig(false));
      }
      yield call(doGenericLogin, responseAux);
    } else {
      yield put(actions.setAuthWindowsAuthConfig(false));
      yield put(actions.setAuthKeycloakAuthConfig(false));
      yield put(actions.failCredentials());
    }
  } catch (exception) {
    yield put(actions.setAuthKeycloakAuthConfig(false));
    yield put(actions.setAuthWindowsAuthConfig(false));
    yield put(actions.failCredentials());
  }
}

export function* requestTempUser() {
  try {
    const token = oauth.getAccessToken();
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    let resp = yield http.get("/api/user/me", config);
    return resp.data.id;
  } catch (exception) {
    return null;
  }
}

export function* getEsliFlow(userId) {
  try {
    const userIdToCall =
      userId !== undefined ? userId : yield call(requestTempUser);
    const headers = {
      Authorization: `Bearer ${oauth.getAccessToken()}`,
      ...PORTALRH_MIDDLEWARE,
    };
    let response = yield call(
      http.get,
      `/api/config/esliflow/${userIdToCall}`,
      {
        headers,
      }
    );
    return response.data;
  } catch (exception) {
    return null;
  }
}

export function* postEsliFlow({ data }) {
  try {
    yield call(http.post, "/api/config/esliflow", data);
  } catch (exception) {
    return null;
  }
}

export function* doWindowsSignInIFlow({ data }) {
  try {
    let response = yield call(http.get, "/api/open/config/windows-auth");
    if (response.data.windowsAuth) {
      let response1;
      try {
        // Corrida entre o pedido e o timeout de 3 segundos
        const { result, timeout } = yield race({
          result: call(
            http.get,
            `/AuthenticationServlet?windows-platform=true`,
            IFLOW_APP
          ),
          timeout: delay(3000),
        });

        if (timeout) {
          window.location.href = "/?kerberosSSOFailed=true";
          yield put(actions.setAuthWindowsAuthConfig(false));
          return;
        }

        response1 = result;
      } catch (error) {
        window.location.href = "/?kerberosSSOFailed=true";
        yield put(actions.setAuthWindowsAuthConfig(false));
        return;

        // if (error.response && error.response.status === 401) {
        //   const wwwAuthenticateHeader =
        //     error.response.headers["www-authenticate"];
        //   // if (wwwAuthenticateHeader && wwwAuthenticateHeader.includes("Negotiate")) {
        //   localStorage.setItem("redirectLoginPage", "true");
        //   if ("caches" in window) {
        //     caches.open("my-cache").then((cache) => {
        //       const request = new Request("/api/data");
        //       const response = new Response(
        //         JSON.stringify({ redirectLoginPage: true }),
        //         {
        //           headers: { "Content-Type": "application/json" },
        //         }
        //       );
        //       cache.put(request, response);
        //     });
        //   }
        //   window.location.href = "/";
        //   yield put(actions.setAuthWindowsAuthConfig(false));
        //   return;
        //   // }
        // }
        // throw error; // Re-throw the error if it's not handled
      }

      let esliflow = response1.headers.esliflow;

      if (esliflow) {
        yield put(actions.setEsliflow(esliflow));
      } else {
        esliflow = yield call(getEsliFlow, data.userId);
        yield call(checkToken);
      }

      let payload = {
        isToSkipConfigs: true,
        login: esliflow,
        uuid: "xpto456",
        history: data.history,
        platform: "windows",
        isIntegratedLogin: true,
      };
      yield call(doWindowsSignIn, { data: payload });
      yield put(actions.setAuthWindowsAuthConfig(true));
    } else {
      yield put(actions.setAuthWindowsAuthConfig(false));
    }
  } catch (exception) {
    yield put(actions.setAuthWindowsAuthConfig(false));
  }
}

export function* doWindowsSignInSignPdf({ data }) {
  try {
    let response = yield http.get("/api/open/config/windows-auth");
    if (response.data.windowsAuth) {
      let token = "xpto456";

      let response1 = yield axios.get(
        `${SIGN_PDF_LOCAL_APP_URL}/get-user-from-windows/${token}`
      );

      let body = {
        username: response1?.data?.username,
      };

      let response2 = yield http.post(
        `/api/open/config/windows-auth/verify-user-with-domain/xpto456`,
        body
      );

      if (response2?.data?.validUser) {
        let payload = {
          isToSkipConfigs: true,
          login: response2?.data?.encryptedUsername,
          uuid: "xpto456",
          history: data.history,
          platform: "windows",
        };
        yield call(doWindowsSignIn, { data: payload });

        yield put(actions.setAuthWindowsAuthConfig(true));
      } else {
        yield put(actions.setAuthWindowsAuthConfig(false));
        yield put(actions.failCredentials());
      }
    } else {
      yield put(actions.setAuthWindowsAuthConfig(false));
    }
  } catch (exception) {
    yield put(actions.setAuthWindowsAuthConfig(false));
    yield put(actions.failCredentials());
  }
}

export function* throwsException(exception, isldpa) {
  const { response } = exception;
  devLogConsole("throwsException", response);

  if (!response || exception.message === "Network Error") {
    yield put(actions.failRemoteServer());
    // if (isldpa == undefined || isldpa == false) {
    //   yield put(toastActiveError("login.error.connectionRemoteServer"));
    // }
  } else if (
    response.data.error === "invalid_grant" ||
    response.status === 428 ||
    response.status === 417
  ) {
    yield put(actions.failCredentials());
    // if (isldpa == undefined || isldpa == false) {
    //   yield put(toastActiveWarning("login.error.badCredentials"));
    // }
  } else if (response.status === 412) {
    yield put(actions.failRemoteServer());
    // if (isldpa == undefined || isldpa == false) {
    //   yield put(toastActiveError("login.error.connectionRemoteServer"));
    // }
  }
}

export function* requestLogout(data) {
  //yield http.get('api/auth/logout');
  yield http.get("/api/auth/logout/" + data.username);
  yield put(actions.setAuthWindowsAuthConfig(false));
  oauth.logout();
}
